import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportSteel },
  },
}: Theme) =>
  createStyles({
    text: {
      position: 'relative',
      display: 'block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      '&:hover $tooltip': {
        visibility: 'visible',
        opacity: 1,
      },
      '&:hover': {
        textOverflow: 'inherit',
        overflow: 'inherit',
      },
    },
    tooltip: {
      visibility: 'hidden',
      borderRadius: `${unit / 2}px`,
      position: 'absolute',
      zIndex: 1,
      opacity: 0,
      transition: 'visibility 0.2s linear,opacity 0.2s linear',
      backgroundColor: colorSupportSteel,
      color: '#FFFFFF',
      padding: `${unit / 2}px ${unit}px`,
      display: 'flex',
      top: '-4px',
      left: '-8px',
    },
  });
